module.exports = __webpack_public_path__ + "static/media/Top_Logos_cdr.22010b99.png";